export default __webpack_public_path__ + "static/media/gallery-img2.0a23b79b.jpeg";